// extracted by mini-css-extract-plugin
export var breadcrumbs = "hero-module--breadcrumbs--zwnIM";
export var content = "hero-module--content--526tV";
export var contentWrapper = "hero-module--contentWrapper--+Exb2";
export var fontsLoading = "hero-module--fonts-loading--JHCwk";
export var h4 = "hero-module--h4--pggcw";
export var heroWrapper = "hero-module--heroWrapper--tnGsx";
export var whiteBlackBottom = "hero-module--whiteBlackBottom--nD1Mj";
export var whiteBlackTop = "hero-module--whiteBlackTop--uyMlC";